<template>
  <div class="catalog__category-subcategories" v-if="filters.length <= 0" v-show="subCategories.length > 0">
    <ul class="grid-x grid-padding-x">
      <sub-category-list-item v-for="(subCategory, index) in subCategories" v-if="index < 4" :key="index" :sub-category="subCategory"></sub-category-list-item>
    </ul>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'SubCategoryList',
    components: {
      'sub-category-list-item': ServiceContainer().getComponent('sub-category-list-item')
    }
  })

  export default class extends Vue {
    @Prop({required: true}) readonly dataSource: string;
    @Prop({required: true}) readonly subCategories: Array<object>;

    private get filters(): Array<object> {
      return this.$store.getters[`CatalogCategory/activeFilters`];
    }

  }
</script>
